import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import "./CompanySelectionModal.css";
import LanguageContext from '../../helper/LanguageContext';
import { DE } from '../../Languages/DE';
import { EN } from '../../Languages/EN';
import { BASE_URL } from '../../helper/constants';
import { convertPosition } from '../../helper/convertor';

function CompanySelectionModal({ companies, onClose }) {
    const { isGerm, strings } = useContext(LanguageContext);
    const history = useHistory();

    const handleCompanySelect = (company) => {
        onClose();
        history.push({
            pathname: `/add-company-article/${company.id}`,
            state: { from: "external", companyId: company.id, fromFeeds: true }
        });
    };

    return (
        <div className="company-selection-modal-backdrop" onClick={onClose}>
            <div 
                className="company-selection-modal-container" 
                onClick={(e) => e.stopPropagation()}
            >
                {/* Modal Header */}
                <div className="company-selection-modal-header">
                    <h5 className="company-selection-modal-title">
                        {strings.company_selection}
                    </h5>
                    <button 
                        type="button"
                        className="kj-btn kj-btn--icon kj-btn--neutral"
                        onClick={onClose}
                    >
                        <span className="material-symbols-outlined close-icon">close</span>
                    </button>
                </div>

                {/* Modal Body */}
                <div className="company-selection-modal-body">
                    {companies && companies.length > 0 ? (
                        companies.map((company) => (
                            <div 
                                key={company.id}
                                className="company-selection-item"
                                onClick={() => handleCompanySelect(company)}
                            >
                                <div className="company-selection-item-info">
                                    <h4 className="company-selection-item-name">{company.name}</h4>
                                    <p className="company-selection-item-address">
                                        {company.full_address ? company.full_address : 
                                            `${company.street}, ${company.postCode}, ${company.city}`}
                                    </p>
                                    <p className="company-selection-item-position">
                                        {strings.my_position} {convertPosition(isGerm, company.position)}
                                    </p>
                                </div>
                                <span className="material-symbols-outlined company-selection-item-arrow">
                                    chevron_right
                                </span>
                            </div>
                        ))
                    ) : (
                    <p className="text-center company-selection-modal__empty">
                        {strings.no_companies_found}
                    </p>
                    )}
                </div>
            </div>
        </div>
    );
}

export default CompanySelectionModal;


